import { BaseDevice, BaseGroup, BaseProfile } from '@lib/core/model';
import { Id, Uuid } from '@lib/core/type';
import { WorkerItem } from '@proget-shared/grid/grid-actions';
import { SelectableItem } from '@proget-shared/grid/selection';
import { StringHelper } from '@proget-shared/helper';

import { Ownership } from '../enum';
import { DeviceNetwork } from '../model';

import { Battery } from './battery';
import { SimInfo } from './sim-info';

export class DeviceListItem extends BaseDevice implements WorkerItem, SelectableItem {
  public readonly updateStatusTranslationKey: string;
  public readonly declarativeManagementTranslationKey: string;

  constructor(
    public readonly id: Id,
    uuid: Uuid,
    public readonly active: boolean,
    public readonly activation: string,
    public readonly lastContact: string,
    public readonly locked: boolean,
    vendor: string,
    model: string,
    public readonly imei: string,
    public readonly serialNumber: string,
    public readonly operatingSystem: string,
    public readonly simInfo: SimInfo[],
    public readonly dep: boolean,
    public readonly profiles: BaseProfile[],
    public readonly securityStatus: string,
    public readonly isActivationLockSupported: boolean | null,
    public readonly ownership: Ownership,
    public readonly language: string,
    public readonly alias: string,
    public readonly mdmClientVersion: string,
    public readonly network: DeviceNetwork,
    public readonly securityPatch: string,
    public readonly buildNumber: string,
    public readonly bootloaderVersion: string,
    public readonly roamingAllowed: boolean,
    public readonly battery: Battery,
    public readonly availableStorage: number,
    public readonly totalStorage: number,
    public readonly firmware: string,
    public readonly progetId: string,
    public readonly activatedAt: string,
    public readonly androidEnterpriseStatus: string,
    public readonly googleServices: boolean | null,
    public readonly updateStatus: string,
    public readonly lastLocationAddress: string,
    public readonly groups: BaseGroup[],
    public readonly declarativeManagement: boolean,
    public readonly wifiMacAddress: string
  ) {
    super(uuid, model, vendor);

    this.updateStatusTranslationKey = this.updateStatus
      ? `library.user_card.devices.list.update_status.option.${StringHelper.transformCase(updateStatus, 'camel', 'snake')}`
      : '';
    this.declarativeManagementTranslationKey = typeof this.declarativeManagement === 'boolean'
      ? `library.user_card.devices.list.declarative_management.option.${this.declarativeManagement ? 'enabled' : 'disabled'}`
      : '-';
  }

  getId(): string {
    return this.uuid;
  }

  getSelectionId(): string {
    return this.id.toString();
  }

  getDisplayName(): string {
    return `${this.vendor} ${this.model}`;
  }

  public availableStoragePercent(): number {
    return 100 - this.availableStorage * 100 / this.totalStorage;
  }
}
